import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import * as Icons from "lucide-react";
import { Plug } from "lucide-react";

const STATUS = {
  available: { label: "Disponibile", cls: "border-emerald-500/40 bg-emerald-500/10 text-emerald-600" },
  not_configured: { label: "Non configurata", cls: "border-slate-400/40 bg-slate-400/10 text-slate-500" },
  coming_soon: { label: "Prossimamente", cls: "border-amber-500/40 bg-amber-500/10 text-amber-600" },
};

function iconFor(name) {
  const map = { "message-circle": Icons.MessageCircle, "building-2": Icons.Building2, webhook: Icons.Webhook, "credit-card": Icons.CreditCard, sparkles: Icons.Sparkles, mail: Icons.Mail, calendar: Icons.Calendar, zap: Icons.Zap, workflow: Icons.Workflow };
  return map[name] || Icons.Plug;
}

export default function Integrations() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: ["integrations"],
    queryFn: async () => (await api.get("/integrations")).data.data,
  });

  return (
    <div>
      <PageHeader title="Integrazioni" subtitle="Collega Connectivity ai tuoi strumenti e servizi" icon={Plug} />
      {isLoading ? (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-40 rounded-xl" />)}</div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {data?.integrations.map((it) => {
            const Icon = iconFor(it.icon);
            const st = STATUS[it.status] || STATUS.not_configured;
            const isMaisonette = it.key === "maisonette";
            return (
              <Card key={it.key} className={`flex flex-col transition-transform hover:-translate-y-1 ${isMaisonette ? "border-primary/40 bg-primary/5" : ""}`} data-testid={`integration-${it.key}`}>
                <CardContent className="flex flex-1 flex-col p-5">
                  <div className="mb-3 flex items-start justify-between">
                    <div className={`flex h-11 w-11 items-center justify-center rounded-xl ${isMaisonette ? "bg-primary text-primary-foreground" : "bg-muted text-foreground"}`}>
                      <Icon className="h-5 w-5" />
                    </div>
                    <Badge variant="outline" className={st.cls}>{st.label}</Badge>
                  </div>
                  <h3 className="font-heading text-base font-semibold">{it.name}</h3>
                  <p className="mt-1.5 flex-1 text-sm text-muted-foreground">{it.description}</p>
                  <Button
                    variant={it.status === "available" ? "default" : "outline"}
                    className="mt-4 w-full rounded-lg"
                    disabled={it.status !== "available"}
                    onClick={() => { if (it.key === "meta_whatsapp") navigate("/whatsapp"); }}
                    data-testid={`configure-${it.key}`}
                  >
                    {it.key === "meta_whatsapp" ? "Configura WhatsApp" : (it.cta || (it.status === "available" ? "Configura" : it.status === "coming_soon" ? "Prossimamente" : "Non configurata"))}
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
